import { FaFile, FaFileAudio, FaFileExcel, FaFileImage, FaFilePdf, FaFilePowerpoint, FaFileVideo, FaFileWord } from "react-icons/fa";

export function friendlyFileIcon(filetype = "", style = { fill: "rgb(209 213 219 / var(--tw-bg-opacity))" }, size = 56) {
    // Return an icon based on the file type use react-icons with file icons
    if (filetype === "application/pdf") {
        return (<FaFilePdf style={style} size={size} />); // PDF icon
    } else if (filetype === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
        return (<FaFileWord style={style} size={size} />); // Word Document icon
    } else if (filetype === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        return (<FaFileExcel style={style} size={size} />); // Excel Spreadsheet icon
    } else if (filetype === "application/vnd.openxmlformats-officedocument.presentationml.presentation") {
        return (<FaFilePowerpoint style={style} size={size} />); // PowerPoint Presentation icon

    } else if (filetype.includes("video/")) {
        return (<FaFileVideo style={style} size={size} />); // Video icon (generic, can be replaced with a specific video icon)
        // audio files
    } else if (filetype.includes("audio/")) {
        return (<FaFileAudio style={style} size={size} />); // Audio icon (generic, can be replaced with a specific audio icon)
        // image files
    } else if (filetype.includes("image/")) {
        return (<FaFileImage style={style} size={size} />); // Image icon
    } else {
        return (<FaFile style={style} size={size} />)
    }
}